import { render, staticRenderFns } from "./EditDeliverysetup.vue?vue&type=template&id=2b51d653&scoped=true"
import script from "./EditDeliverysetup.vue?vue&type=script&lang=js"
export * from "./EditDeliverysetup.vue?vue&type=script&lang=js"
import style0 from "./EditDeliverysetup.vue?vue&type=style&index=0&id=2b51d653&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b51d653",
  null
  
)

export default component.exports